import d from "lodash/isNumber";
function o(t) {
  return window.getComputedStyle ? getComputedStyle(t, null) : t.currentStyle;
}
function f(t) {
  const { zIndex: e } = o(t);
  return parseInt(e);
}
function v(t) {
  const { width: e } = o(t);
  return parseFloat((e || "").replace("px", ""));
}
function w(t) {
  const { height: e } = o(t);
  return parseFloat((e || "").replace("px", ""));
}
function b(t) {
  const { borderWidth: e } = o(t);
  return parseFloat((e || "").replace("px", ""));
}
function S(t, e) {
  t && Object.keys(e).forEach((n) => {
    let r = "";
    [
      "minWidth",
      "maxWidth",
      "minHeight",
      "maxHeight",
      "width",
      "height",
      "top",
      "right",
      "bottom",
      "left",
      "marginLeft",
      "marginRight",
      "marginTop",
      "marginBottom"
    ].includes(n) && d(e[n]) && (r = "px"), t.style[n] = e[n] + r;
  });
}
function x(t) {
  const e = o(t);
  return {
    marginLeft: parseInt(e.marginLeft) || 0,
    marginRight: parseInt(e.marginRight) || 0,
    marginTop: parseInt(e.marginTop) || 0,
    marginBottom: parseInt(e.marginBottom) || 0
  };
}
function O(t, e) {
  Object.keys(e).forEach((n) => {
    e[n] !== !1 ? t.setAttribute(n, e[n]) : t.removeAttribute(n);
  });
}
function s(t, e) {
  return t && t.classList.contains(e);
}
function H(t, e) {
  t && s(t, e) && t.classList.remove(e);
}
function N(t, e) {
  t && !s(t, e) && t.classList.add(e);
}
function T(t = document.body) {
  return t === !0 ? document.body : t instanceof window.Node ? t : document.querySelector(t);
}
function W(t, e) {
  let n = 0, r = 0;
  do
    n += t.offsetTop || 0, r += t.offsetLeft || 0, t = t.offsetParent;
  while (t && t !== e);
  return {
    top: n,
    left: r
  };
}
function m(t) {
  const n = t instanceof HTMLElement && o(t).overflowY, r = n !== "visible" && n !== "hidden";
  return t ? r && t.scrollHeight >= t.clientHeight ? t : m(t.parentNode) || document.body : null;
}
function C(t) {
  let e, n = null;
  const r = (...i) => {
    e = i, !n && (n = requestAnimationFrame(() => {
      n = null, t(...e);
    }));
  };
  return r.cancel = () => {
    n && (cancelAnimationFrame(n), n = null);
  }, r;
}
function u({ clientHeight: t, scrollHeight: e }) {
  return e > t;
}
function a({ clientWidth: t, scrollWidth: e }) {
  return e > t;
}
function h(t) {
  return u(t) || a(t);
}
function E(t) {
  const e = a(t), { overflowX: n } = o(t);
  return e && ["auto", "scroll"].includes(n);
}
function A(t) {
  const e = u(t), { overflowY: n } = o(t);
  return e && ["auto", "scroll"].includes(n);
}
function g(t, e = document.body) {
  const n = document.createTreeWalker(e, NodeFilter.SHOW_TEXT), r = [];
  for (; n.nextNode(); ) {
    const i = n.currentNode;
    i.nodeType === Node.TEXT_NODE && i.textContent.includes(t) && r.push(i.parentNode);
  }
  return r;
}
function F(t, e) {
  const [n] = g(t, e);
  return !(!n || !h(n));
}
async function I() {
  return new Promise((t) => {
    requestAnimationFrame(t);
  });
}
function L(t) {
  return t && /^\d+(px)$/.test(t);
}
function B(t) {
  return t && /^\d+%$/.test(t);
}
function P(t) {
  return t !== null && typeof t == "object" && Object.hasOwn(t, "componentOptions");
}
function p() {
  return [".pendo-modal.is-open", ".pendo-drawer.is-open", ".pendo-notification"].reduce((e, n) => {
    const r = document.querySelectorAll(n);
    return e.concat(...r);
  }, []).filter((e) => e.style.display !== "none");
}
function X() {
  return p().reduce((t, e) => {
    const n = f(e);
    return n > t ? n : t;
  }, 0);
}
let l, c;
function Y() {
  if (l !== void 0)
    return l;
  const t = document.createElement("div");
  t.style.visibility = "hidden", t.style.width = "100px", t.style.msOverflowStyle = "scrollbar", document.body.appendChild(t);
  const e = t.offsetWidth;
  t.style.overflow = "scroll";
  const n = document.createElement("div");
  n.style.width = "100%", t.appendChild(n);
  const r = n.offsetWidth;
  return t.parentNode.removeChild(t), l = e - r, l;
}
function j() {
  if (c !== void 0)
    return c;
  const t = document.createElement("div");
  t.style.visibility = "hidden", t.style.height = "100px", t.style.msOverflowStyle = "scrollbar", document.body.appendChild(t);
  const e = t.offsetHeight;
  t.style.overflow = "scroll";
  const n = document.createElement("div");
  n.style.height = "100%", t.appendChild(n);
  const r = n.offsetHeight;
  return t.parentNode.removeChild(t), c = e - r, c;
}
export {
  N as addClass,
  h as elementHasOverflow,
  a as elementHasOverflowX,
  u as elementHasOverflowY,
  E as elementHasScrollX,
  A as elementHasScrollY,
  W as elementPositionInAncestor,
  g as findNodeByContent,
  p as getAllVisibleOverlays,
  b as getBorderWidth,
  w as getHeight,
  x as getMargin,
  m as getScrollParent,
  j as getScrollbarHeight,
  Y as getScrollbarWidth,
  o as getStyle,
  T as getTarget,
  X as getTopZindex,
  v as getWidth,
  f as getZIndex,
  s as hasClass,
  B as isPercent,
  L as isPx,
  P as isVNode,
  I as nextFrame,
  C as raf,
  H as removeClass,
  O as setAttributes,
  S as setStyles,
  F as shouldAttachOverflowTooltip
};
//# sourceMappingURL=dom.js.map
